export default __webpack_public_path__ + "static/media/lds-logo_ru.452bf3cfa8676314.svg";